import builder from '../builder';
import Pencil1 from '../../streamline-icons/bold/pencil-1.svg';

export default builder('IconPencil1Bold', Pencil1);
